module.exports = __webpack_public_path__ + "static/img/tag-kaoji@2x.49affe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tag-kaoji@2x.png
// module id = 1622
// module chunks = 0